const angular = require('angular');

const { fulfilmentMethodWizardComponentDefinition } = require('./fulfilment-method-wizard.component');
const { fulfilmentMethodWizardComponentDefinitionV2 } = require('./fulfilment-method-wizard.component.v2');

angular.module('wowApp.fulfilment')
    .component('wowFulfilmentMethodWizard', fulfilmentMethodWizardComponentDefinition)
    .component('wowFulfilmentMethodWizardV2', fulfilmentMethodWizardComponentDefinitionV2)
    .constant('FulfilmentSteps', Object.freeze({
        fulfilmentMethod: 'FULFILMENT_METHOD',
        address: 'ADDRESS',
        timeslot: 'TIMESLOT',
        billing: 'BILLING',
    }));



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentmethod/index.js